import React, { useEffect, useState } from 'react'
import { Property, PropertyNew } from '../../../../types/Property/Property'
import { useTranslation } from 'next-i18next'
import dynamic from 'next/dynamic'
import DetailsBullets from './DetailsBullets'
import DetailsParagraphIcon from '../DetailsParagraphIcon'
import DetailsCardIcon from '../DetailsCardIcon'
import PropertyNews from './PropertyNews'
import useLocale from '../../../../hooks/useLocale'

const LeafletMap = dynamic(() => import('../../../LeafletMap'), {
  ssr: false,
})

type PropertySectionProps = {
  className?: string
  property: Property
  propertyNews: PropertyNew[]
}

export default function InfoSection({
  className,
  property,
  propertyNews,
}: PropertySectionProps) {
  const { t } = useTranslation('originals/property')
  const [propertyGlobalInfos, setPropertyGlobalInfos] = useState<any>()
  const [propertyInfosProsAndCons, setPropertyInfosProsAndCons] =
    useState<any>()
  const [propertyInfosParagraphs, setPropertyInfosParagraphs] =
    useState<string[]>()
  const [neighborhoodInfos, setNeighborhoodInfos] = useState<any>()

  useEffect(() => {
    if (!property) return

    setPropertyGlobalInfos(
      property.translation.descriptions.propertyDetails?.globalInfos ?? '',
    )
    setPropertyInfosProsAndCons(
      property.translation.descriptions.propertyDetails?.propertyInfos
        ?.prosAndCons ?? '',
    )
    setPropertyInfosParagraphs(
      Object.values(
        property.translation.descriptions.propertyDetails?.propertyInfos
          ?.paragraphs ?? '',
      ),
    )
    setNeighborhoodInfos(
      property.translation.descriptions.propertyDetails?.neighborhoodInfos ??
        '',
    )
  }, [property])

  console.log('InfoSection#propertyNews', propertyNews)

  return (
    <div className={className}>
      <div className="border-b border-dashed border-neutralGray/50 pb-3">
        <PropertyNews news={propertyNews} />

        <DetailsBullets property={property} />

        <div className="pb-2 pt-2">
          {propertyGlobalInfos &&
            Object.keys(propertyGlobalInfos).map((key) => (
              <div key={key} className="pt-2">
                <DetailsParagraphIcon
                  key={key}
                  icon={propertyGlobalInfos[key].icon}
                  title={propertyGlobalInfos[key].title}
                  text={propertyGlobalInfos[key].text}
                />
              </div>
            ))}
        </div>
      </div>

      <div className="mt-4">
        <h2 className="font-bold text-neutralBlack">
          {t('infoSection.learnMore')}
        </h2>
        <div className="mt-1">
          <div className="grid grid-cols-1 gap-1.5 pb-2 text-justify text-sm text-neutralBlack">
            {propertyInfosParagraphs &&
              propertyInfosParagraphs.map((p, index) => {
                return (
                  <p key={index} className="text-sm font-light">
                    {p}
                  </p>
                )
              })}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-2 pb-4 sm:grid-cols-2 sm:gap-4">
          {propertyInfosProsAndCons &&
            Object.keys(propertyInfosProsAndCons).map((key) => (
              <div key={key} className="pt-2">
                <DetailsCardIcon
                  key={key}
                  icon={propertyInfosProsAndCons[key].icon}
                  title={propertyInfosProsAndCons[key].title}
                  text={propertyInfosProsAndCons[key].text}
                />
              </div>
            ))}
        </div>

        <div className="mb-3 overflow-hidden rounded-2xl">
          <LeafletMap
            centerCoordinates={[property.lat, property.lon]}
            zoom={14}
            leafletPoints={[
              {
                lat: property.lat,
                lon: property.lon,
                pin: true,
                zone: 0.5,
              },
            ]}
            classname="h-56"
          />
        </div>

        <div>
          <h2 className="font-bold text-neutralBlack">
            {neighborhoodInfos && neighborhoodInfos.title}
          </h2>
          <p className="mt-1 text-justify text-sm font-light text-neutralBlack">
            {neighborhoodInfos && neighborhoodInfos.text}
          </p>
        </div>
      </div>
    </div>
  )
}
